var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1784 14.0833C19.4889 16.0335 18.2117 17.7219 16.5226 18.9158C14.8335 20.1098 12.8158 20.7506 10.7473 20.75C8.93938 20.7495 7.16541 20.2589 5.61415 19.3304C4.06289 18.4019 2.79237 17.0702 1.93777 15.477C1.08317 13.8838 0.67646 12.0888 0.760921 10.2828C0.845382 8.47689 1.41785 6.72763 2.41742 5.22117C3.41698 3.71471 4.80625 2.50741 6.4374 1.72773C8.06855 0.948046 9.88056 0.625152 11.6806 0.793402C13.4807 0.961652 15.2015 1.61475 16.6599 2.68321C18.1183 3.75167 19.2598 5.19551 19.9628 6.86111",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0811 7.41666H17.4144C18.9855 7.41666 19.7711 7.41667 20.2588 6.92778C20.7477 6.44111 20.7477 5.65555 20.7477 4.08333V0.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.3b22c3b8ad5e4d8ebea6194100eac952.svg";
export { ForwardRef as ReactComponent };